<template>
  <b-container fluid>

    <b-row class="table-header">
      <b-col cols="12" offset-lg="6" lg="6" offset-xl="9" xl="3">
        <b-form-group>
          <b-form-input
            ref="search"
            v-model="meta.search"
            :disabled="fetching"
            placeholder="Search by name"
            @input="searchChanged"/>
        </b-form-group>
      </b-col>
    </b-row>

    <no-data v-if="noData" message="No topics found..."/>

    <b-table
      v-if="data.length"
      ref="table"
      :hover="!fetching"
      :responsive="true"
      :fixed="true"
      :busy="fetching"
      :items="data"
      :fields="formFields"
      :per-page="Number(meta.per_page)"
      :sort-by="meta.order"
      :sort-desc="meta.desc"
      :no-local-sorting="true"
      class="client-table"
      @sort-changed="sortChanged"
      @row-clicked="rowClicked">

      <template slot="order" slot-scope="data">
        <b-container fluid>
          <b-row>
            <b-col cols="12">
              <div class="name-wrapper">
                <span class="name">
                  {{ data.item.name }}
                </span>
                <b-button
                  v-if="role !== 'owner'"
                  :disabled="fetching"
                  size="lg"
                  variant="link"
                  @click.stop="toggle_favorite(data.item)">
                  <img v-if="showingFavorites || data.item.is_favorite" class="star" alt="starred" src="../../../../../assets/images/star-solid.svg">
                  <img v-else alt="not starred" class="star" src="../../../../../assets/images/star-regular.svg">
                </b-button>
                <span v-if="data.item.totalProcedures > 0" class="ratio">
                  <b-badge v-if="data.item.isCompleted" variant="success">{{ data.item.completedProcedures }} / {{ data.item.totalProcedures }} completed</b-badge>
                  <b-badge v-else variant="danger">{{ data.item.completedProcedures }} / {{ data.item.totalProcedures }} completed</b-badge>
                </span>
                <span v-if="data.item.knowledgecheck_id" class="ratio"> 
                  <b-link :disabled="fetching" :to="{name:'client-knowledgecheck', params:knowledgeCheckParams(data.item)}" >
                    <b-badge variant="success">knowledge check</b-badge>
                  </b-link>
                </span>
              </div>
              <div v-if="showingFavorites" class="metadata">
                <i>In module:</i> {{ data.item.component.module.name }}
                <br>
                <i>In component:</i> {{ data.item.component.name }}
              </div>
              <div class="description">
                {{ data.item.description }}
              </div>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-table>

    <b-row>
      <b-col cols="12">
        <b-pagination
          v-if="data.length"
          :disabled="fetching"
          :value="Number(meta.current_page)"
          :total-rows="Number(meta.total)"
          :per-page="Number(meta.per_page)"
          @change="pageChanged"/>
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import tableMixin from '../../mixins/client-table'
import { mapState, mapGetters } from 'vuex'

export default {
  mixins: [tableMixin],
  data () {
    return {
      namespace: 'topics',
      routeParamName: 'topic',
      rowClickRoute: 'client-items',
      formFields: [
        { key: 'order', label: 'Order' }
      ]
    }
  },
  computed: {
    ...mapState('client', {
      favoritesFetching: 'fetchingFavoriteTopics'
    }),
    ...mapGetters('client', {
      role: 'getCurrentRole'
    }),
    showingFavorites () {
      const favoritesView = this.$store.state[this.namespace]._favoritesView
      return this.view === favoritesView
    }
  },
  methods: {
    defaultParams(item){
      const params = { topic: item.id }
      if(this.showingFavorites){
        params.module = item.component.module.id
        params.component = item.component.id
      }
      return params
    },
    toggle_favorite (topic) {
      if (this.showingFavorites) {
        this.$store.dispatch('topics/toggleFavorite', {
          view: this.view,
          fetchIndex: true,
          isFavorite: true,
          componentID: topic.component.id,
          topicID: topic.id
        })
      } else {
        this.$store.commit('topics/patch', {
          view: this.view,
          id: topic.id,
          update: {is_favorite: !topic.is_favorite}
        })
        this.$store.dispatch('topics/toggleFavorite', {
          isFavorite: topic.is_favorite,
          componentID: topic.component.id,
          topicID: topic.id
        })
      }
    },
    rowClicked (item, index, e) {
      if (!this.rowClickEnabled) {
        return
      }

      let params = { topic: item.id }

      // if we are viewing favorite topics, the module and component ids are
      // not already in the url
      if (this.showingFavorites) {
        params = {
          module: item.component.module.id,
          component: item.component.id,
          topic: item.id
        }
      }

      this.$router.push({
        name: 'client-items',
        params
      })
    },
    completedRatio (id) {
      return this.$store.getters['topics/completedRatio'](id)
    }, 
    knowledgeCheckParams(item){
      const params = this.defaultParams(item)
      params.knowledgecheckId = item.knowledgecheck_id
      return params
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

.name-wrapper {
  display: flex;
  align-items: flex-end;

  .name {
    margin-right: $spacing-xs;
  }

  button {
    margin-left: $spacing-xs;
    margin-right: $spacing-xs;
    padding: 0;

    .star {
      width: 20px !important;
      height: auto !important;
    }
  }

  .ratio {
    margin: 0;
    padding: 0;
    font-size: 18px;
    margin-left: $spacing-xs;
  }
}

.metadata {
  color: $brand-dark-primary;
}

.fa-star {
  color: $brand-light-secondary;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/client/topics/table.vue